/**
 * Cache em memória + dedupe de in-flight para `shipper/{id}`.
 * Evita leituras duplicadas (ex.: menu + listagem de frete na mesma abertura).
 */

const TTL_MS = 5 * 60 * 1000;

/** @type {Map<string, { value: any, expiresAt: number }>} */
const cache = new Map();

/** @type {Map<string, Promise<any>>} */
const inFlight = new Map();

export function peekShipperDocCache(id) {
  const key = String(id || "").trim();
  if (!key) return undefined;
  const entry = cache.get(key);
  if (!entry) return undefined;
  if (entry.expiresAt <= Date.now()) {
    cache.delete(key);
    return undefined;
  }
  return entry.value;
}

export function setShipperDocCache(id, value) {
  const key = String(id || "").trim();
  if (!key) return;
  cache.set(key, { value, expiresAt: Date.now() + TTL_MS });
}

export function clearShipperDocCache(id) {
  if (id == null) {
    cache.clear();
    inFlight.clear();
    return;
  }
  const key = String(id).trim();
  cache.delete(key);
  inFlight.delete(key);
}

/**
 * @param {string} id
 * @param {() => Promise<any>} loader
 */
export async function getShipperDocCached(id, loader) {
  const key = String(id || "").trim();
  if (!key) return null;

  const hit = peekShipperDocCache(key);
  if (hit !== undefined) return hit;

  const pending = inFlight.get(key);
  if (pending) return pending;

  const promise = Promise.resolve()
    .then(() => loader())
    .then((value) => {
      setShipperDocCache(key, value ?? null);
      return value ?? null;
    })
    .finally(() => {
      inFlight.delete(key);
    });

  inFlight.set(key, promise);
  return promise;
}
